/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const topFeaturesSpecsVersionHistorySlice = createSlice({
  name: 'topFeaturesSpecsVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default topFeaturesSpecsVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = topFeaturesSpecsVersionHistorySlice.actions;
